"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EnumType = (function () {
    function EnumType(value) {
        this.value = value;
    }
    return EnumType;
}());
exports.EnumType = EnumType;
//# sourceMappingURL=EnumType.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/json-to-graphql-query/lib/types/EnumType.js
// module id = 786
// module chunks = 0